import { ManhattanPlotDataGroup } from 'Shared/plots/models';
import { ManhattanPlotData } from 'Shared/plots/models/ManhattanPlotData/ManhattanPlotData';
import { CHAPTER_NUMBER_PATTERN } from 'Common/consts';
/**
 * Returns data for plot rendering
 * @param categories array of phenotypic categories
 * @param dataPointsMapper util for mapping from array to collection
 * @returns data for plot points rendering
 */
export const getPlotDataFromCategories = (categories, dataPointsMapper) => categories.reduce((acc, category, index) => {
    var _a;
    const { name, shortName } = category;
    const groupId = name;
    let groupLabel = shortName !== null && shortName !== void 0 ? shortName : `${index + 1}`;
    let groupName = name;
    // Roman numeral for binary traits if no short label was provided
    if (!shortName) {
        const [findMatch, findLabel] = CHAPTER_NUMBER_PATTERN.exec(name) || [];
        if (findLabel) {
            groupLabel = findLabel;
        }
        if (findMatch) {
            groupName = name.replace(findMatch, '');
        }
    }
    if ((_a = dataPointsMapper[name]) === null || _a === void 0 ? void 0 : _a.length) {
        acc.addGroup(new ManhattanPlotDataGroup(groupName, groupLabel, dataPointsMapper[name].length, dataPointsMapper[name], groupId));
    }
    return acc;
}, ManhattanPlotData.empty);
